export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/4a216fcc-6675-4827-bb88-94ed8e2b363a.jpg",
  productBox: "https://cdn.magicpatterns.com/patterns/generated-images/2e5808cc-4972-4a33-8bdb-c87715ffb39e.jpg",
  workbench: "https://cdn.magicpatterns.com/patterns/generated-images/d97812c5-c8c7-4c0e-9f89-39b83364cfb1.jpg",
  transformBench: "https://cdn.magicpatterns.com/patterns/generated-images/3daa9529-8fa8-4d9e-93f9-98a1a2327100.jpg",
  outdoor: "https://cdn.magicpatterns.com/patterns/generated-images/dadead0e-0a32-4ab4-bf53-efec5bbee985.jpg",
  robot: "https://cdn.magicpatterns.com/patterns/generated-images/2f8c3a10-c88e-43df-99ec-a78a44d71c13.jpg",
  drillStation: "https://cdn.magicpatterns.com/patterns/generated-images/644f4720-0a0a-40dc-8b5d-b41a4e66d468.jpg",
  chair: "https://cdn.magicpatterns.com/patterns/generated-images/46b2bfc9-5f48-4682-9560-5b961d91672e.jpg",
  shelf: "https://cdn.magicpatterns.com/patterns/generated-images/0044a435-caef-473a-b0da-f2477a0cbad4.jpg",
  blueprint: "https://cdn.magicpatterns.com/patterns/generated-images/2002fa71-bfaa-44cb-9450-9158c2700511.jpg",
};

export const testimonials = [
  {
    name: "Mike T.",
    location: "Austin, TX",
    text: "The plans are crystal clear. I finished my first bench in a single weekend without wasting a board. The cut list alone saved me hours.",
  },
  {
    name: "Rachel K.",
    location: "Portland, OR",
    text: "I'd never built anything before, and now there's a ladder shelf in my living room. The step-by-step guides make it easy to follow along.",
  },
  {
    name: "David L.",
    location: "Toronto, CA",
    text: "I walk into the lumber yard with everything already calculated. Five projects in and each one has turned out better than the last.",
  },
  {
    name: "Jenna W.",
    location: "Denver, CO",
    text: "The 2-in-1 designs are brilliant. The bench that flips into a picnic table is the most-used thing in our backyard.",
  },
];

export const bundleFeatures = [
  "150+ woodworking plans ready to download",
  "Illustrated step-by-step guides for every project",
  "Exact measurements in inches and mm/cm",
  "Ready-to-use cut and material lists",
  "Space-saving 2-in-1 transforming projects",
  "Beginner, intermediate and advanced levels",
  "Instant lifetime access on any device",
  "Free updates with new projects",
];

export const whyReasons = [
  { title: "Plans that actually make sense", text: "Clean diagrams with front, side and top views so you never second-guess the next step." },
  { title: "Zero wasted material", text: "Every plan includes an optimized cut list to get the most out of each board." },
  { title: "Designed for your space", text: "Furniture that folds, transforms or does two jobs in a single build." },
];

export type FeatureBlock = {
  titleDark: string;
  titleAccent: string;
  paragraphs: string[];
  bullets?: string[];
  image: string;
  imageAlt: string;
  reverse?: boolean;
  cta?: boolean;
};

export const featureBlocks: FeatureBlock[] = [
  {
    titleDark: "Build with confidence,",
    titleAccent: "no experience required",
    paragraphs: [
      "Every project is explained as if a seasoned woodworker were standing next to you. No unnecessary jargon, and every joint is illustrated.",
      "Start with simple pieces and work up to more complex furniture at your own pace.",
    ],
    image: images.transformBench,
    imageAlt: "Wooden bench that converts into a picnic table",
    cta: true,
  },
  {
    titleDark: "Build a workshop",
    titleAccent: "that works for you",
    paragraphs: ["Organize your tools and work comfortably by building your own shop furniture."],
    bullets: [
      "Mobile workbenches with drawers and storage",
      "Pegboards and tool holders",
      "Folding cutting stations for small spaces",
      "Custom clamp carts and side tables",
    ],
    image: images.workbench,
    imageAlt: "Wooden workbench with a tool wall",
    reverse: true,
  },
  {
    titleDark: "Not just classic projects,",
    titleAccent: "endless possibilities",
    paragraphs: [
      "Beyond chairs, tables and shelves, you'll find transforming designs that change function in seconds.",
      "Perfect for small homes, balconies, patios or any corner where every inch counts.",
    ],
    image: images.shelf,
    imageAlt: "Wooden ladder shelf with plants",
    cta: true,
  },
  {
    titleDark: "See what it looks like",
    titleAccent: "in the real world",
    paragraphs: [
      "These aren't impossible renders: they're projects built by people like you, with common tools, in home garages.",
      "Garden playhouses, dining chairs, shelving and much more, all with professional-looking finishes.",
    ],
    image: images.outdoor,
    imageAlt: "Wooden garden playhouse with a red door",
    reverse: true,
  },
];

export const galleryImages = [
  { src: images.chair, alt: "Wooden dining chair" },
  { src: images.shelf, alt: "Ladder shelf" },
  { src: images.outdoor, alt: "Garden playhouse" },
  { src: images.transformBench, alt: "Transforming bench" },
  { src: images.workbench, alt: "Workbench" },
  { src: images.drillStation, alt: "Drill press station" },
];

export const projectCategories = [
  {
    title: "Outdoor projects",
    text: "Benches, planters, pergolas, playhouses and picnic tables designed to stand up to the weather and bring your yard to life.",
    image: images.outdoor,
  },
  {
    title: "Indoor projects",
    text: "Chairs, coffee tables, shelving and organizers that blend function and style for every room in the house.",
    image: images.blueprint,
  },
  {
    title: "Workshop essentials",
    text: "Workbenches, stands, jigs and stations that make your shop safer, tidier and more efficient.",
    image: images.workbench,
  },
];

export const bonusItems = [
  "Full drill press station plan with drawers",
  "Compact, mobile drill press station plan",
  "Cut and hardware lists for both versions",
  "3D views and assembly diagrams",
];

export const trustItems = [
  { title: "100% secure checkout", text: "Your purchase is processed with end-to-end encryption and the most trusted payment methods." },
  { title: "Ongoing support", text: "Stuck on a plan? Our team replies by email within 24 hours." },
  { title: "Instant delivery", text: "Get your download link by email seconds after completing your order." },
];

export const aiPoints = [
  { title: "Instant answers", text: "Ask which screw to use or how to cut a joint and get a clear reply." },
  { title: "Adjust dimensions", text: "Ask it to resize a plan to fit your exact space." },
  { title: "Available 24/7", text: "Your shop assistant is always ready, even at midnight." },
];

export const comparisonRows = [
  "150+ detailed plans",
  "Measurements in inches and cm",
  "Optimized cut lists",
  "2-in-1 transforming projects",
  "Smart assistant included",
  "Free lifetime updates",
];

export const faqs = [
  { q: "How do I receive the plans after purchase?", a: "Right after payment you'll get an email with your download link. You can access everything from your computer, tablet or phone." },
  { q: "Do I need woodworking experience?", a: "No. The collection includes beginner projects with step-by-step instructions, and you'll find more challenging builds as you progress." },
  { q: "What tools do I need?", a: "Most projects only need basic tools: a saw, drill, sander, square and tape measure. Each plan lists the specific tools required." },
  { q: "Are measurements in imperial or metric?", a: "Both. Every plan includes measurements in inches as well as millimeters and centimeters." },
  { q: "Is there a money-back guarantee?", a: "Yes. If you're not satisfied, you have 30 days to request a full refund, no questions asked." },
];
